// extracted by mini-css-extract-plugin
export default {"upload-img":"UploadImage_upload-img__lNAPn","error":"UploadImage_error__XiGAL"};